import React, { Fragment, useState } from 'react';
import Form from 'react-bootstrap/Form';
export default function RenderForm({
  handleSubmit,
  errors,
  showErrorMsg,
  fields,
  isSuccess,
  handleFieldChange,
  validateForm,
}) {
  return (
    <div className="add-user-container">
      <div className="add-user-form">
        {showErrorMsg && (
          <div className="error-message-end">{showErrorMsg}</div>
        )}
        {isSuccess && (
          <div className="success-message">
            {isSuccess}
          </div>
        )}
        <Form onSubmit={handleSubmit}>
          <div className="add-user-form--wrapper">
            <div className="add-user-form--row">
              <div className="add-user-form--col">
                <div className="add-user-form--group">
                  <Form.Group controlId="firstName" size="lg">
                    <Form.Label className="form-label">
                      First Name <span className="field-required">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      maxLength="25"
                      className={
                        errors.fName
                          ? 'form-control field-error'
                          : 'form-control'
                      }
                      placeholder="First Name"
                      value={fields.firstName}
                      onChange={handleFieldChange}
                    />
                  </Form.Group>
                </div>
              </div>
            </div>
            <div className="add-user-form--row">
              <div className="add-user-form--col">
                <div className="add-user-form--group">
                  <Form.Group controlId="lastName" size="lg">
                    <Form.Label className="form-label">
                      Last Name <span className="field-required">*</span>{' '}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      className={
                        errors.lName
                          ? 'form-control field-error'
                          : 'form-control'
                      }
                      placeholder="Last Name"
                      maxLength="25"
                      onChange={handleFieldChange}
                      value={fields.lastName}
                    />
                  </Form.Group>
                </div>
              </div>
            </div>{' '}
            <div className="add-user-form--row">
              <div className="add-user-form--col">
                <div className="add-user-form--group">
                  <Form.Group controlId="emailLogin" size="lg">
                    <Form.Label className="form-label">
                      Email Address<span className="field-required">*</span>
                    </Form.Label>
                    <Form.Control
                      placeholder="Email Address"
                      type="email"
                      maxLength="75"
                      className={
                        errors.email
                          ? 'form-control field-error'
                          : 'form-control'
                      }
                      value={fields.emailLogin}
                      onChange={handleFieldChange}
                    />
                  </Form.Group>
                </div>
              </div>{' '}
            </div>{' '}
            <div className="add-user-form--row">
              <div className="add-user-form--col">
                <div className="add-user-form--group">
                  <Form.Group controlId="activationKey" size="lg">
                    <Form.Label className="form-label">
                      Activation Key <span className="field-required">*</span>
                    </Form.Label>
                    <Form.Control
                      placeholder="Activation Key"
                      type="text"
                      maxLength="255"
                      className={
                        errors.activationKey
                          ? 'form-control field-error'
                          : 'form-control'
                      }
                      value={fields.activationKey}
                      onChange={handleFieldChange}
                    />
                  </Form.Group>
                </div>
              </div>
            </div>{' '}
            <div className="add-user-form--row">
              <div className="add-user-form--col">
                <div className="add-user-form--group">
                  <button
                    block="true"
                    size="lg"
                    type="submit"
                    variant="primary"
                  >
                    Proceed
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
}
